import { useUser } from "@app/features/user/hooks/useUser"
import * as Sentry from "@sentry/react"
import { useEffect } from "react"

export const SentryUserContext = () => {
    const { data: userData } = useUser()

    useEffect(() => {
        if (userData?.user) {
            Sentry.setUser({
                ...userData.user,
                id: String(userData.user.id),
                email: userData.user.email,
                username: userData.user.username,
                name: `${userData.user.first_name}${userData.user.last_name ? ` ${userData.user.last_name}` : ""}`,
            })

            if (userData.agency) {
                Sentry.setContext("agency", {
                    id: userData.agency.id,
                    name: userData.agency.name,
                    nif: userData.agency.nif,
                    subdomain: userData.agency.subdomain,
                })

                // Also set as tags for easier filtering/searching
                Sentry.setTag("agency_id", userData.agency.id)
                Sentry.setTag("agency_name", userData.agency.name)
            }
        } else {
            // Clear user scope if no user data (e.g. logout)
            Sentry.setUser(null)
            Sentry.setContext("agency", null)
            Sentry.setTag("agency_id", undefined)
            Sentry.setTag("agency_name", undefined)
        }
    }, [userData])

    return null
}
